import { useEffect, useRef, useState } from 'react';

export function useFavoriteHeart(props: { isFavorited: boolean }) {
  const { isFavorited } = props;
  const wasFavorited = useRef(isFavorited);
  const [isPopping, setIsPopping] = useState(false);

  useEffect(() => {
    if (isFavorited && !wasFavorited.current) {
      setIsPopping(true);
    } else if (!isFavorited) {
      setIsPopping(false);
    }
    wasFavorited.current = isFavorited;
  }, [isFavorited]);

  return { isPopping, onAnimationEnd: () => setIsPopping(false) };
}
